import Vue from 'vue';

function Claim(name) {
	if (!(this instanceof Claim)) {
		return new Claim(name);
	}
	this.$name = name;
}

Claim.prototype.toString = function () {
	return '[Claim ' + (this.$name || 'non-specific') + ']';
};

function mapRole(role, map) {
	var claims = role.split(':');
	for (var claim, i = 0, len = claims.length; i<len; i++) {
		claim = claims[i];
		if (!map.hasOwnProperty(claim)) {
			map[claim] = new Claim(claim);
		}
		map = map[claim];
	}
}

function mapRoles(roles) {
	var map = {};
	for (var claims, role, i = 0, len = roles && roles.length || 0; i<len; i++) {
		mapRole(roles[i], map);
	}
	return map;
}

function validateRole(role, map) {
	if (!map) {
		return false;
	}
	var claims = role.split(':');
	for (var claim, i = 0, len = claims.length; i<len; i++) {
		claim = claims[i];
		if (!map.hasOwnProperty(claim) || map[claim] === null) {
			return false;
		}
		map = map[claim];
	}
	return true;
}

function toDate(value) {
	var date = value ? new Date(value): void 0;
	return isFinite(+date) ? date : null;
}

function User(config) {
	if (!(this instanceof User)) {
		return new User();
	}
	Vue.util.extend(this, config);
}

User.prototype.constructor = User;

User.prototype.can = function (role) {
	return validateRole(role, this.roles);
};

User.prototype.getMatchingClaims = function (claimStartStr) {
	return (this.token && this.token.claims || []).filter((claim) => {
		return claim.startsWith(claimStartStr);
	});
};

User.prototype.getLimitByClaim = function (claimStartStr) {
	let creditClaims = this.getMatchingClaims(claimStartStr);
	let limits = creditClaims.map(claim => {
		let limitClaimParts = claim.split(':');
		let limit = Number(limitClaimParts[limitClaimParts.length - 1]);
		return limit === 0 ? Infinity : limit;
	});
	if (limits && limits.length) {
		return Math.max(...limits);
	}
	return 0;
};

User.prototype.toJSON = function () {
	return User.toDTO(this);
};

User.toDTO = function toDTO(user) {
	var plan = user && user.plan || {};
	return user ? {
		id: user.id,
		email: user.email,
		roles: user.roles,
		cidrRestriction: user.cidrRestriction,
		trackingEnabled: user.allowDataCollection,
		isMfaEnabled: user.mfa.enabled,
		lastAuthDate: user.lastAuthDate,
		status: user.accessStatus,
		billingStatus: user.paymentMethodStatus,
	}: null;
};

User.fromDTO = function fromDTO(dto) {
	if (!dto) {
		return null;
	}
	var token = dto.token || {};
	var user = dto.user || dto;

	return new User({
		id: user.id,
		email: user.email,
		roles: mapRoles(token.claims || user.roles),
		cidrRestriction: user.cidrRestriction,
		allowDataCollection: user.trackingEnabled,
		isMfaEnabled: user.mfa.enabled,
		lastAuthDate: toDate(token.iat),
		token: token,
		activeKeys: user.activeKeys,
		status: user.accessStatus, // ActivePaid
	});
};

export default User;



// WEBPACK FOOTER //
// ./src/modules/user/user.js